export default "__VITE_ASSET__B4HM$w1w__"